module.exports = __webpack_public_path__ + "media/images/shared/psychology-today-38aba3b096081c8d3314dca51559d180dd570362405184622c07ae82d141d9db.png";